export const SCREEN_TYPES = ['Summary', 'Data']

export const DEFAULT_AI_MODEL = 'Claude 3 Haiku'

export const AI_MODELS = [
  { name: 'Claude 3 Haiku', multiplier: '1x' },
  { name: 'Claude 3.5 Haiku', multiplier: '3.2x' },
  { name: 'Claude 3.5 Sonnet', multiplier: '12x' },
  { name: 'Claude 3.5 Sonnet v2', multiplier: '12x' },
  { name: 'Claude 3.7 Sonnet', multiplier: '12x' },
  { name: 'Claude Sonnet 4', multiplier: '12x' },
]

export const DATA_SOURCES = {
  activity: 'activity',
  survey: 'survey',
  event: 'event',
}

export const SELECT_BY_OPTIONS = {
  organizations: {
    key: 'organizations',
    type: 'Organization',
    label: 'Organizations Profiles',
    defaultDataSource: DATA_SOURCES.activity,
  },
  people: {
    key: 'people',
    type: 'Person',
    label: 'People Profiles',
    defaultDataSource: DATA_SOURCES.activity,
  },
  events: {
    key: 'events',
    type: 'Event',
    label: 'Event Name',
    defaultDataSource: DATA_SOURCES.event,
  },
  surveys: {
    key: 'surveys',
    type: 'Survey',
    label: 'Pulse Survey Name',
    defaultDataSource: DATA_SOURCES.survey,
  },
  organizations_by_uuid: {
    key: 'organizations_by_uuid',
    type: 'Organization',
    label: 'Organization by UUID',
    defaultDataSource: DATA_SOURCES.activity,
  },
  people_by_uuid: {
    key: 'people_by_uuid',
    type: 'Person',
    label: 'Person by UUID',
    defaultDataSource: DATA_SOURCES.activity,
  },
  events_by_uuid: {
    key: 'events_by_uuid',
    type: 'Event',
    label: 'Event by UUID',
    defaultDataSource: DATA_SOURCES.event,
  },
  surveys_by_uuid: {
    key: 'surveys_by_uuid',
    type: 'Survey',
    label: 'Survey by UUID',
    defaultDataSource: DATA_SOURCES.survey,
  },
}

export const SECURITY_DEPENDENT_ENTITIES = ['surveys', 'events']

export const selectionIsProfile = selection => {
  return selection === 'Organization' || selection === 'Person'
}
